import React, { useState, useMemo } from 'react';
import Show from './Show/Show';
import ShowsJsonLd from './ShowsJsonLd';
import './Shows.css';

// Flyer imports - Current/Upcoming
import mar27_2025 from './Flyers/march27-2025-3L.webp';
import may17_2025 from './Flyers/may17thRGFlyer.jpg';
import may24_2025 from './Flyers/may24-2025-DW.webp';
import july23_2025 from './Flyers/july23_2025.jpeg';
import aug8_2025 from './Flyers/aug8thzounds.jpeg';
import aug25_2025 from './Flyers/aug25_txtearoom.jpeg';
import sept4th_2025 from './Flyers/sept4_haltomTheater.webp';
import oct11th_2025 from './Flyers/oct_11-DW.jpg';
import nov8th_renos from './Flyers/nov8_renos.jpg';
import nov9th_2025_dustys from './Flyers/nov9th_2025_dustys.webp';
import jan31st_2026 from './Flyers/jan31-2026_Sunshine.webp';
import mar27_2026_houseshow from './Flyers/march27_2026_houseshow.jpg';
import mar28_2026_rubbergloves from './Flyers/mar28_rubbergloves_2026_update.jpg';
import april3rd_2026_renos from './Flyers/april3rd_2026_renos.webp';
import april30_2026_renos from './Flyers/april30_2026_renos.jpg';
import may31_2026_rubbergloves from './Flyers/may31_2026_rubbergloves.jpg';
import may15_2026_doublewide from './Flyers/May5_2026_DoubleWide_Meldamor.png';
import may22_2026_rubbergloves from './Flyers/May22_2026_RubberGloves_OxygenDestroyer.webp';
import june11_2026_metrobaltimore from './Flyers/June11_2026_MetroBaltimore_NuclearTomb_TOUR.webp';
import june16_2026_greenlantern from './Flyers/June16_2026_GreenLanternBar_Kontusion_TOUR.jpeg';
import june4th_2026_houston from './Flyers/June4th_2026_Houston.PNG';
import june6th_2026_birmingham from './Flyers/june6th_2026_birmingham.webp';
import june9th_2026_northcarolina from './Flyers/june9th_2026_NorthCarolina.webp';
import june12th_2026_newyorkcity from './Flyers/june12th_2026_NewYorkCity.webp';
import june7th_2026_atlanta from './Flyers/June7th_2026_Atlanta.webp';
import june10th_2026_richmond from './Flyers/June10th_2026_Richmond.PNG';
import july26th_2026_peticolas from './Flyers/july26_2026-Peticolas.webp';
import aug2nd_2026_doublewide from './Flyers/aug2_2026-Doublewide.webp';
import sept5th_2026_renos from './Flyers/sept5_renos_2026.png';
import sep12th_2026_haltom from './Flyers/september_haltom.png';
import oct29th_2026_dustys from './Flyers/mortalizer-dustys-october29-2026.webp';
import nov28th_2026_growl from './Flyers/nov28Growl2026.jpg';
import dec5th_2026_clubdada from './Flyers/Warhog_12.5.26_IG_Post.png';

// Flyer imports - Past shows
import may28th from './Flyers/may28thDWshow.webp';
import may31st from './Flyers/may31RGshow.png';
import june4th from './Flyers/june4thSunshineBar.jpg';
import june22nd from './Flyers/june22ndDWshow.jpg';
import june27th from './Flyers/june27th.PNG';
import june30th from './Flyers/june30thCharliesShow.PNG';
import august16th from './Flyers/august16th.webp';
import sept14th from './Flyers/growlRecordsShowFlyer.jpeg';
import sept27th from './Flyers/sept-27-flyer.webp';
import oct4 from './Flyers/oct4-renos.webp';
import oct13 from './Flyers/oct13-growl.PNG';
import fm2m from './Flyers/from-man2mist-version2.webp';

export default function Shows() {
    const [pastShowsExpanded, setPastShowsExpanded] = useState(false);

    // Helper to parse dates with ordinal suffixes (1st, 2nd, 3rd, 4th, etc.)
    const parseShowDate = (dateStr) => {
        const cleaned = dateStr.replace(/(\d+)(st|nd|rd|th)/, '$1');
        return new Date(cleaned);
    };

    // price, doors and showTime are optional - the hero renders whichever are present
    const shows = [
        // 2024 Shows (Past)
        { flyer: '.' + may28th, alt: 'may_28th_2024_DoubleWide', date: 'May 28th, 2024', venue: 'DoubleWide', address: '3510 Commerce St, Dallas, TX', bands: ['Ascended Dead', 'Cognizant', 'Psychiatric Regurgitation'] },
        { flyer: '.' + may31st, alt: 'may_31st_2024_RubberGloves', date: 'May 31st, 2024', venue: 'Rubber Gloves', address: '411 E Sycamore St, Denton, TX 76205', bands: ['HERAKLEION', 'Morgue Meat', 'Kudu'] },
        { flyer: '.' + june4th, alt: 'june_4th_2024_SunshineBar', date: 'June 4th, 2024', venue: 'Sunshine Bar', address: '902 W Division St, Arlington, TX 76012', bands: ['Viogression', 'Yotuma'] },
        { flyer: '.' + june22nd, alt: 'june_22nd_2024_DoubleWide', date: 'June 22nd, 2024', venue: 'DoubleWide', address: '3510 Commerce St, Dallas, TX', bands: ['Spiter', 'Desolus', 'Nocturnal Wolf', 'Hofaker'] },
        { flyer: '.' + june27th, alt: 'june_27th_2024_HaltomTheater', date: 'June 27th, 2024', venue: 'Haltom Theater', address: '5601 E Belknap St, Haltom City, TX 76117', bands: ['Distain', 'Void', 'Odius', 'Kudu'] },
        { flyer: '.' + june30th, alt: 'june_30th_2024_CharliesStarLounge', date: 'June 30th, 2024', venue: "Charlie's Star Lounge", address: '4319 Main St, Dallas, TX 75226', bands: ['Festival'] },
        { flyer: '.' + august16th, alt: 'august_16th_2024_DoubleWide', date: 'August 16th, 2024', venue: 'DoubleWide', address: '3510 Commerce St, Dallas, TX', bands: ['Oxygen Destroyer', 'Morgue Meat'] },
        { flyer: '.' + sept14th, alt: 'sept_14th_2024_GrowlRecords', date: 'September 14th, 2024', venue: 'Growl Records', address: '509 E Abram St, Arlington, TX 76010', bands: ['Festival'] },
        { flyer: '.' + sept27th, alt: 'sept_27th_2024_ZoundsBSide', date: 'September 27th, 2024', venue: 'Zounds B-Side', address: '10050 Shoreview Rd, Dallas, TX 75238', bands: ['AKA', 'Solly'] },
        { flyer: '.' + oct4, alt: 'october_4th_2024_Renos', date: 'October 4th, 2024', venue: 'Renos', address: '210 N Crowdus St, Dallas, TX 75226', bands: ['In Human Form', 'Mouth of Cronus', 'Norman Invasion'] },
        { flyer: '.' + oct13, alt: 'october_13th_2024_GrowlRecords', date: 'October 13th, 2024', venue: 'Growl Records', address: '509 E Abram St, Arlington, TX 76010', bands: ['Civil Serpents', 'Negative Influence', 'Bliss Fields'] },
        { flyer: '.' + fm2m, alt: 'october_25th_2024_CheapSteaks', date: 'October 25th, 2024', venue: 'Cheap Steaks', address: '2613 Elm St, Dallas, TX 75226', bands: ['Festival'] },
        { flyer: '.' + fm2m, alt: 'december_7th_2024_RenosChopShop', date: 'December 7th, 2024', venue: "Reno's Chop Shop", address: '210 N Crowdus St, Dallas, TX 75226', bands: ['Festival'] },
        // 2025 Shows
        { flyer: '.' + mar27_2025, alt: 'march_27th_2025_ThreeLinks', date: 'March 27th, 2025', venue: 'Three Links', address: '2704 Elm St, Dallas, TX 75226', bands: ['Void', 'Odious', 'Carnist'] },
        { flyer: '.' + may17_2025, alt: 'may_17th_2025_RubberGloves', date: 'May 17th, 2025', venue: 'Rubber Gloves', address: '411 E Sycamore St, Denton, TX 76205', bands: ['Pale Misery', 'Tsuris', 'Nocturnal Spawn'] },
        { flyer: '.' + may24_2025, alt: 'may_24th_2025_DoubleWide', date: 'May 24th, 2025', venue: 'DoubleWide', address: '3510 Commerce St, Dallas, TX', bands: ['Volcandra', 'Saidan', 'Inverted Candles'] },
        { flyer: '.' + july23_2025, alt: 'july_23_2025_RubberGloves', date: 'July 23rd, 2025', venue: 'Rubber Gloves', address: '411 E Sycamore St, Denton, TX 76205', bands: ['Eternal', 'Nocturnal Spawn', 'Repulse'] },
        { flyer: '.' + aug8_2025, alt: 'aug_8th_2025_ZoundsBSide', date: 'August 8th, 2025', venue: 'Zounds B-Side', address: '10050 Shoreview Rd, Dallas, TX 75238', bands: ['Throat Locust', 'Animus', 'No Gimmicks'] },
        { flyer: '.' + aug25_2025, alt: 'aug_25th_TXTeaRoom', date: 'August 25th, 2025', venue: 'TX Tea Room', address: '2815 Main St Suite B, Dallas, TX 75226', bands: ['Panpsychism', 'Psychiatric Regurgitation', 'Cynical'] },
        { flyer: '.' + sept4th_2025, alt: 'sept_4th_HaltomTheater', date: 'September 4th, 2025', venue: 'Haltom Theater', address: '5601 E Belknap St, Haltom City, TX 76117', bands: ['Labyrinth', 'Warhog', 'Skull Archer', 'Odious'] },
        { flyer: '.' + oct11th_2025, alt: 'oct_11th_DoubleWide', date: 'October 11th, 2025', venue: 'DoubleWide', address: '3510 Commerce St, Dallas, TX', bands: ['Tencher', 'Sadistic Force', 'Accuser', 'Narcissist'] },
        { flyer: '.' + nov8th_renos, alt: 'nov_8th_RenosChopShop', date: 'November 8th, 2025', venue: "Reno's Chop Shop", address: '210 N Crowdus St, Dallas, TX 75226', bands: ['Evil Army', 'Silver Tongue Devil', 'Accuser', 'Odious'] },
        { flyer: '.' + nov9th_2025_dustys, alt: 'nov_9th_Dustys', date: 'November 9th, 2025', venue: "Dusty's", address: '2613 Elm St, Dallas, TX 75226', bands: ['Satanik Heavy Drinker', 'Chemical Spell', 'Carnist'] },
        // 2026 Shows
        { flyer: '.' + jan31st_2026, alt: 'jan_31st_2026_SunshineBar', date: 'January 31st, 2026', venue: 'Sunshine Bar', address: '902 W Division St, Arlington, TX 76012', bands: ['Real Life Ugly', 'Bladda', 'S.H.I.V.'] },
        { flyer: '.' + mar27_2026_houseshow, alt: 'march_27th_2026_HouseParty', date: 'March 27th, 2026', venue: 'House Show', address: '10826 Joaquin Dr, Dallas, TX 75228', bands: ['DJHOTSAUCE', 'Pastel Sky', 'We Decree', 'Sallyworld', 'fixtionr.', '$OLUMDOLOR', 'WYNTER', 'ILLUSIONLUNA', 'SERPENT PRIEST'] },
        { flyer: '.' + mar28_2026_rubbergloves, alt: 'march_28th_2026_RubberGloves', date: 'March 28th, 2026', venue: 'Rubber Gloves', address: '411 E Sycamore St, Denton, TX 76205', bands: ['Myth Carver', 'Primal Tyrant', 'Terminal Nation', 'Morbid Visionz', 'Turn Cold', 'Kombat', 'Defense Wound', 'Ritual Fog', 'Nemesis', 'Ignominious', 'Ritual Abuse', 'Morta', 'Distain', 'Unadorned', 'Cynical'] },
        { flyer: '.' + april3rd_2026_renos, alt: 'april_3rd_2026_RenosChopShop', date: 'April 3rd, 2026', venue: "Reno's Chop Shop", address: '210 N Crowdus St, Dallas, TX 75226', bands: ['Void', 'Phantom', 'Accuser'] },
        { flyer: '.' + april30_2026_renos, alt: 'april_30th_2026_RenosChopShop', date: 'April 30th, 2026', venue: "Reno's Chop Shop", address: '210 N Crowdus St, Dallas, TX 75226', bands: ['Lord Velvet', 'Kamru', 'Diavola'] },
        { flyer: '.' + may15_2026_doublewide, alt: 'may_15th_2026_DoubleWide', date: 'May 15th, 2026', venue: 'DoubleWide', address: '3510 Commerce St, Dallas, TX', bands: ['Meldamor', 'Sucio', 'Special Agent', 'La Bruja (DJ)', 'Llora (DJ)'] },
        { flyer: '.' + may22_2026_rubbergloves, alt: 'may_22nd_2026_RubberGloves', date: 'May 22nd, 2026', venue: 'Rubber Gloves', address: '411 E Sycamore St, Denton, TX 76205', bands: ['Oxygen Destroyer', 'Drawn and Quartered', 'Nocturnal Spawn'] },
        { flyer: '.' + may31_2026_rubbergloves, alt: 'may_31st_2026_RubberGloves', date: 'May 31st, 2026', venue: 'Rubber Gloves', address: '411 E Sycamore St, Denton, TX 76205', bands: ['Gammacide', 'Silver Tongue Devil', 'Chemicaust'] },
        { flyer: '.' + june4th_2026_houston, alt: 'june_4th_2026_BlackMagicSocialClub', date: 'June 4th, 2026', venue: 'Black Magic Social Club', address: '7036 Harrisburg Blvd, Houston, TX 77011', bands: ['Lethal Agent', 'Galactic Zombies', 'Metallize'] },
        { flyer: '.' + june6th_2026_birmingham, alt: 'june_6th_2026_TrueStoryBrewing', date: 'June 6th, 2026', venue: 'True Story Brewing Co.', address: '5510 Crestwood Blvd, Birmingham, AL 35242', bands: ['Ramtha', 'Ectovoid', 'The Crimson Mask'] },
        { flyer: '.' + june7th_2026_atlanta, alt: 'june_7th_2026_BoggsSocialAndSupply', date: 'June 7th, 2026', venue: 'Boggs Social & Supply', address: '1310 White St SW, Atlanta, GA 30310', bands: ['Spew', 'Dungeon Filth', 'tubefed'] },
        { flyer: '.' + june9th_2026_northcarolina, alt: 'june_9th_2026_Kings', date: 'June 9th, 2026', venue: 'Kings', address: '14 West Martin Street, Raleigh, NC 27601', bands: ['Zero Tolerance', 'Deceptor', 'Crooked Cult'] },
        { flyer: '.' + june10th_2026_richmond, alt: 'june_10th_2026_CobraCabana', date: 'June 10th, 2026', venue: 'Cobra Cabana', address: '901 W Marshall St, Richmond, VA 23220', bands: ['Deceptor', 'Eradicant', 'Bonewretch'] },
        { flyer: '.' + june12th_2026_newyorkcity, alt: 'june_12th_2026_TheAttic', date: 'June 12th, 2026', venue: 'The Attic', address: '20 Meadow St, Brooklyn, NY 11206', bands: ['Lord Humongous', 'Flesh Mass', 'Mordant Rhed', 'Syn'] },
        { flyer: '.' + june11_2026_metrobaltimore, alt: 'june_11th_2026_MetroBaltimore', date: 'June 11th, 2026', venue: 'Metro Baltimore', address: '1700 N Charles St, Baltimore, MD 21201', bands: ['Nuclear Tomb', 'Eyecatcher', 'Obliviator'] },
        { flyer: '.' + june16_2026_greenlantern, alt: 'june_16th_2026_GreenLanternBar', date: 'June 16th, 2026', venue: 'Green Lantern Bar', address: '497 W 3rd St, Lexington, KY 40508', bands: ['Kontusion', 'Neglect', 'Sinistrum', 'Dungeon'] },
        { flyer: '.' + july26th_2026_peticolas, alt: 'july_26th_2026_Peticolas', date: 'July 26th, 2026', venue: 'Peticolas', address: '1301 Pace St, Dallas, TX', bands: ['Real Life Ugly', 'Disaster'] },
        { flyer: '.' + aug2nd_2026_doublewide, alt: 'august_2nd_2026_DoubleWide', date: 'August 2nd, 2026', venue: 'DoubleWide', address: '3510 Commerce St, Dallas, TX', bands: ['Eternal', 'Brain Matter', 'Prisoner of War'] },
        { flyer: '.' + sept5th_2026_renos, alt: 'sept_5th_2026_RenosChopShop', date: 'September 5th, 2026', venue: "Reno's Chop Shop", address: '210 N Crowdus St, Dallas, TX 75226', bands: ['Smoking Nuns', 'Blindlace'] },
        { flyer: '.' + sep12th_2026_haltom, alt: 'sep_12th_2026_HaltomTheater', date: 'September 12th, 2026', venue: 'Haltom Theater', address: '5601 E Belknap St, Haltom City, TX 76117', bands: ['Sanity Slip', 'Voracious Contempt', 'Dysmorphia', 'Primal Tyrant', 'Distain', 'Brain Matter', 'Gator', '(side stage to Mortician)'] },
        { flyer: '.' + oct29th_2026_dustys, alt: 'oct_29th_2026_Dustys', date: 'October 29th, 2026', venue: "Dusty's", address: '2613 Elm St, Dallas, TX 75226', bands: ['Mortalizer', 'Duskseeker'], price: '$15', doors: '7:00 PM', showTime: '8:00 PM' },
        { flyer: '.' + nov28th_2026_growl, alt: 'nov_28th_2026_GrowlRecords', date: 'November 28th, 2026', venue: 'Growl Records', address: '509 E Abram St, Arlington, TX 76010', bands: ['Insurgency', 'Carnist', 'Expat', 'Largactyl', 'No-Fun'], price: '$10', doors: '5:00 PM', showTime: '6:00 PM' },
        { flyer: '.' + dec5th_2026_clubdada, alt: 'dec_5th_2026_ClubDada', date: 'December 5th, 2026', venue: 'Club Dada', address: '2720 Elm St, Dallas, TX 75226', bands: ['Helstar', 'Warhog', 'Diavola'], price: '$20 adv / $25 door', doors: '7:00 PM' },
        { flyer: '.' + fm2m, alt: 'feb_4th_2027_TheLostWell', date: 'February 4th, 2027', venue: 'The Lost Well', address: '1141 1/2 Airport Blvd, Austin, TX 78702', bands: ['Saint Breaker'] },
    ];

    // Parse dates and separate upcoming vs past
    const { upcoming, past } = useMemo(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const upcomingShows = shows
            .filter(s => parseShowDate(s.date) >= today)
            .sort((a, b) => parseShowDate(a.date) - parseShowDate(b.date));

        const pastShows = shows
            .filter(s => parseShowDate(s.date) < today)
            .sort((a, b) => parseShowDate(b.date) - parseShowDate(a.date)); // Most recent first

        return { upcoming: upcomingShows, past: pastShows };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const nextShow = upcoming[0];
    const otherUpcoming = upcoming.slice(1);

    // Generate random rotation for poster wall effect
    const getRandomRotation = (index) => {
        const seed = index * 7919;
        return ((seed % 7) - 3); // Range: -3 to 3 degrees
    };

    // "8:00 PM" / "8 PM" / "10:30pm" -> { hours, minutes }, or null if unparseable.
    // A bare time is read as PM below 12, since these are all evening shows.
    const parseTimeOfDay = (timeStr) => {
        const match = /^(\d{1,2})(?::(\d{2}))?\s*(am|pm)?$/i.exec(timeStr.trim());
        if (!match) return null;

        let hours = parseInt(match[1], 10);
        const minutes = match[2] ? parseInt(match[2], 10) : 0;
        const meridiem = match[3] && match[3].toLowerCase();
        if (hours > 23 || minutes > 59) return null;

        if (meridiem === 'pm' && hours < 12) hours += 12;
        else if (meridiem === 'am' && hours === 12) hours = 0;
        else if (!meridiem && hours < 12) hours += 12;

        return { hours, minutes };
    };

    // Generate Google Calendar URL
    const generateCalendarUrl = (show) => {
        const date = parseShowDate(show.date);
        const start = parseTimeOfDay(show.showTime || '') || { hours: 20, minutes: 0 };
        date.setHours(start.hours, start.minutes, 0, 0);
        // Same 3-hour block the hardcoded 8-11pm used to assume
        const endDate = new Date(date);
        endDate.setHours(endDate.getHours() + 3);

        const formatDate = (d) => d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';

        // showTime is already the event's start, so only doors and price need saying
        const details = [`Maldevera live at ${show.venue}`, '', `With: ${show.bands.join(', ')}`];
        if (show.doors || show.price) {
            details.push('');
            if (show.doors) details.push(`Doors: ${show.doors}`);
            if (show.price) details.push(`Price: ${show.price}`);
        }

        const params = new URLSearchParams({
            action: 'TEMPLATE',
            text: `Maldevera @ ${show.venue}`,
            dates: `${formatDate(date)}/${formatDate(endDate)}`,
            location: show.address,
            details: details.join('\n')
        });

        return `https://calendar.google.com/calendar/render?${params.toString()}`;
    };

    // "2613 Elm St, Dallas, TX 75226" -> "Dallas, TX"
    const getCityState = (address) => {
        const city = address.split(',')[1]?.trim();
        const state = address.split(',')[2]?.trim().split(' ')[0];
        return `${city}, ${state}`;
    };

    // Generate Google Maps directions URL
    const generateDirectionsUrl = (address) => {
        return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
    };

    return (
        <div className="shows-wrapper">
            {/* Search-engine structured data for the upcoming dates. Renders no UI. */}
            <ShowsJsonLd upcoming={upcoming} parseShowDate={parseShowDate} />

            {/* Hero Section - Next Show */}
            {nextShow && (
                <section className="hero-show">
                    <div className="hero-flyer-container">
                        <Show show={nextShow} mode="hero" />
                    </div>
                    <div className="hero-details">
                        <span className="hero-label">Next Show</span>
                        <h2 className="hero-date">{nextShow.date}</h2>
                        <h3 className="hero-venue">
                            @ {nextShow.venue}
                            <span className="hero-city">{getCityState(nextShow.address)}</span>
                        </h3>
                        <div className="hero-bands">
                            {nextShow.bands.map((band, idx) => (
                                <span key={idx} className="hero-band">
                                    {band.toUpperCase()}
                                </span>
                            ))}
                        </div>
                        {(nextShow.doors || nextShow.showTime || nextShow.price) && (
                            <dl className="hero-meta">
                                {nextShow.doors && (
                                    <div className="hero-meta-item">
                                        <dt className="hero-meta-label">Doors</dt>
                                        <dd className="hero-meta-value">{nextShow.doors}</dd>
                                    </div>
                                )}
                                {nextShow.showTime && (
                                    <div className="hero-meta-item">
                                        <dt className="hero-meta-label">Show</dt>
                                        <dd className="hero-meta-value">{nextShow.showTime}</dd>
                                    </div>
                                )}
                                {nextShow.price && (
                                    <div className="hero-meta-item">
                                        <dt className="hero-meta-label">Price</dt>
                                        <dd className="hero-meta-value">{nextShow.price}</dd>
                                    </div>
                                )}
                            </dl>
                        )}
                        <div className="hero-actions">
                            <a
                                href={generateDirectionsUrl(nextShow.address)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hero-btn hero-btn-directions"
                            >
                                Directions
                            </a>
                            <a
                                href={generateCalendarUrl(nextShow)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hero-btn hero-btn-calendar"
                            >
                                Add to Calendar
                            </a>
                        </div>
                    </div>
                </section>
            )}

            {/* Upcoming Shows - Poster Wall */}
            {otherUpcoming.length > 0 && (
                <section className="upcoming-section">
                    <h2 className="section-header">Upcoming Shows</h2>
                    <div className="poster-wall">
                        {otherUpcoming.map((show, idx) => (
                            <div
                                key={idx}
                                className="poster-card"
                                style={{ '--rotation': `${getRandomRotation(idx)}deg` }}
                                data-tape={getCityState(show.address)}
                            >
                                <Show
                                    show={show}
                                    mode="poster"
                                    calendarUrl={generateCalendarUrl(show)}
                                    directionsUrl={generateDirectionsUrl(show.address)}
                                />
                            </div>
                        ))}
                    </div>
                </section>
            )}

            {/* Past Shows - Collapsible */}
            {past.length > 0 && (
                <section className="past-section">
                    <button
                        className={`past-header ${pastShowsExpanded ? 'expanded' : ''}`}
                        onClick={() => setPastShowsExpanded(!pastShowsExpanded)}
                    >
                        <span>Past Shows ({past.length})</span>
                        <span className="past-toggle-arrow">
                            {pastShowsExpanded ? '▲' : '▼'}
                        </span>
                    </button>
                    {pastShowsExpanded && (
                        <div className="poster-wall poster-wall-past">
                            {past.map((show, idx) => (
                                <div
                                    key={idx}
                                    className="poster-card poster-card-past"
                                    style={{ '--rotation': `${getRandomRotation(idx + 100)}deg` }}
                                    data-tape={getCityState(show.address)}
                                >
                                    <Show show={show} mode="poster" isPast={true} />
                                </div>
                            ))}
                        </div>
                    )}
                </section>
            )}

            {/* Fallback if no shows */}
            {upcoming.length === 0 && (
                <h2 className="no-shows-message">
                    No upcoming shows, check back soon!
                </h2>
            )}
        </div>
    );
}
